import { ol_VectorLayer, ol_Feature, ol_FeatureLike, ol_Map, ol_MapBrowserPointerEvent, ol_source, ol_style, ol_layer } from "@omnia/exports/openlayers";
import { IMapContainer, observeOpenlayersObject } from "../../../omnia";
import { AnalysisLayer, IAnalysisLayerData } from "./analysis-layer";
import { HighlightOverlay } from "./highlight-overlay";

export class Highlight {

    private _olmap: ol_Map;

    private _pointerWatcher: Function;

    private _highlighLayer: ol_VectorLayer;

    private _highlight: {
        feature: ol_FeatureLike;
        overlay: HighlightOverlay;
    }

        constructor(private map: IMapContainer) {
            this._olmap = this.map.getMap();
        }

    dispose() {

        if (this._pointerWatcher) {
            this._pointerWatcher();
            this._pointerWatcher = null;
        }

        this.highlightFeature(null);

        if (this._highlighLayer) {
            this._olmap.removeLayer(this._highlighLayer);
            this._highlighLayer = null;
        }

    }

    public deactivate() {
        this.dispose();
    }

    public activate() {

        this.dispose();

        this._pointerWatcher = observeOpenlayersObject(this._olmap, "pointermove", event => this.onPointerMove(event));

        this._highlighLayer = this.createLayer(this._highlightStyle);

    }

    private createLayer(style: ol_style.Style[]) {

        let layer = new ol_layer.Vector({
            source: new ol_source.Vector({
                useSpatialIndex: false,
            }),
            updateWhileAnimating: true,
            updateWhileInteracting: true,
            style: style
        });

        this._olmap.addLayer(layer);

        return layer;

    }

    private onPointerMove(event: ol_MapBrowserPointerEvent) {
        this.highlightFeatureAtPointer(event);
    }

    private highlightFeatureAtPointer(event: ol_MapBrowserPointerEvent) {

        let match: ol_FeatureLike

        if (!event.dragging) {

            this._olmap.forEachFeatureAtPixel(event.pixel, (feature, olayer) => {

                let layer = feature.get("layer");

                if (layer instanceof AnalysisLayer) {
                    match = feature;
                    return true;

                }

            });

        }

        this.highlightFeature(match);

    }

    private highlightFeature(feature: ol_FeatureLike) {

        if (!this._highlighLayer) return;

        if (this._highlight) {
            if (this._highlight.feature === feature) return;
            this._highlight.overlay.dispose();
            this._highlighLayer.getSource().clear();
            this._highlight = null;
        }

        if (feature) {

            let data = <IAnalysisLayerData>feature.get("data");
            let geom = (<any>(feature.getGeometry())).clone();
            let hlfeature = new ol_Feature(geom);
            hlfeature.set("data", { data: data });
            this._highlighLayer.getSource().addFeature(hlfeature);

            let overlay = new HighlightOverlay(hlfeature, this._olmap);

            this._highlight = {
                feature,
                overlay
            };
        }

    }

    private _highlightStyle = [

        new ol_style.Style({

            fill: new ol_style.Fill({
                color: 'rgba(255, 255, 255, 0.35)'
            }),

            stroke: new ol_style.Stroke({
                color: 'rgb(36, 96, 240)',
                width: 5
            })

        }),

        new ol_style.Style({

            stroke: new ol_style.Stroke({
                color: 'rgb(255, 255, 255)',
                width: 1
            })

        })


    ];


}
